export default __webpack_public_path__ + "static/media/email.fea9296d.svg";